<template>
  <PageHeader
    :image="PerguntasFrequentesBannerImage"
    ariaLabel="Pessoas correndo"
    :minHeight="421"
    title="Dúvidas"
    text="Consulte nossas perguntas frequentes."
  />
</template>

<script>
import PageHeader from '@/components/PageHeader'
import PerguntasFrequentesBannerImage from '@/images/homeBanner.png'

export default {
  name: 'BannerRegulamento',
  components: {
    PageHeader,
  },
  data: () => ({
    PerguntasFrequentesBannerImage,
  })
}
</script>
